export default class TestBattleShipService {
  static weapons(ship) {
    return this.devices_by_kind(ship, 'weapon')
  }

  static protections(ship) {
    return this.devices_by_kind(ship, 'protector')
  }

  static devices_by_kind(ship, kind) {
    return ship.devices.filter(item => item.kind === kind)
  }

  static calculatePowerConsumption(devices) {
    let pwr = 0
    devices
      .filter(item => item.enabled === true)
      .forEach(item => pwr += (item.power_consumption || 0))
    return pwr
  }

  static calculateMaxPowerConsumption(devices) {
    let pwr = 0
    devices
      .forEach(item => pwr += (item.power_consumption || 0))
    return pwr
  }

  static calculatePowerGeneration(devices) {
    let pwr = 0
    devices
      .filter(item => item.enabled === true)
      .forEach(item => pwr += (item.power_generation || 0))
    return pwr
  }

}
